// To be kept in sync with the limits defined in backend\RoadFootage.Core\Data\UserProfileDetailsDto.cs and FieldLimits.cs.
export const emailAddress = 320
export const familyName = 50
export const givenName = 50
export const fullName = givenName + familyName + 1
export const nickname = givenName + familyName
export const phoneNumber = 15
export const url = 2048
export const organisationName = 40
export const titleOrPosition = 20
export const address = 80
export const ipv6Address = 39
export const countryCode = 3
export const role = 10
export const timezone = 64
export const primaryUserIncidentFileId = 36 // UUID string length
// Address fields
export const addressRawInput = 500
export const addressFormatted = 500
export const addressUnitNumber = 20
export const addressLevelNumber = 20
export const addressStreetNumber = 20
export const addressStreetName = 150
export const addressStreetType = 50
export const addressSuburb = 100
export const addressState = 10
export const addressPostcode = 10
export const addressCountry = 100
export const addressSecondaryStreet = 150
export const addressLandmark = 200
// Bounty owner's reason for rejecting a response
export const bountyResponseDecisionReason = 1000
// Region bounds (for lat/lon validation, if needed)
export const minLatitude = -44.0
export const maxLatitude = -9.0
export const minLongitude = 96.0
export const maxLongitude = 168.0
// General fields
export const subject = 128
export const objectKey = 1024
// Long user-generated text fields
export const userSubmittedIncidentDescription = 2048
export const incidentDescription = 2048
